const NO_SPECIAL_CHAR = /^[A-Za-z0-9]*$/

const REGEX = {
	NAME_FULL: /^([A-z|À-ú|Ä-ü]{2,}(\s+[A-z|À-ú|Ä-ü]{2,})+$)/,
	NAME_NON_NUMERIC: /^[A-z|À-ú|Ä-ü|\s]*[A-z|À-ú|Ä-ü]+$/,
	PASSWORD_NON_NUMERIC: /\b(?=.*[a-z])(?=.*)\b/i,
	PASSWORD_NUMERIC: /\b(?=.*[0-9])\b/,
	PHONE: /(^[0-9]{2}[1-8][0-9]{3}[0-9]{4}$|^[0-9]{2}9[0-9]{4}[0-9]{4})$/,
	CELLPHONE: /(?:\()[0-9]{2}(?:\))\s?[9]{1}[0-9]{4}(?:-)[0-9]{4}$/,
	RG: NO_SPECIAL_CHAR,
	SECURITY_KEY: /^[0-9]{4}$/,
	EMAIL_MOVEFLEX: /^[A-Za-z0-9._%+-]+@pontosmoveflex.com.br|[A-Za-z0-9._%+-]+@jmt.com.br$|[A-Za-z0-9._%+-]+@muviflex.com.br$/,
	NUMBERS_AND_SPACES: /[^a-z\s]/gi,
	NO_SPECIAL_CHAR,
	ONLYDIGITS: /^[0-9]*$/gi,
	COUPON: NO_SPECIAL_CHAR,
	CURRENCY: /^[0-9]{1,13}(,[0-9]{0,2})?$/g,
	PASSWORD_MIN_LENGTH: /.{12,}/, // Verifica o mínimo de 12 caracteres
	PASSWORD_UPPERCASE: /(?=.*[A-Z])/, // Pelo menos um caractere maiúsculo
	PASSWORD_LOWERCASE: /(?=.*[a-z])/, // Pelo menos um caractere minúsculo
	PASSWORD_NUMERIC: /(?=.*[0-9])/, // Pelo menos um dígito
	PASSWORD_SPECIAL_CHAR: /(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/, // Pelo menos um caractere especial
}

export default REGEX
